import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import _ from 'lodash';
// import { notification } from 'antd';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';

const mapData = [];
export class MapsStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      maps: [],
      mapsInfo: [],
      map: {},
      mapData: _.cloneDeep(mapData),
      allMapData: [],
      offset: 0,
      limit: 15,
      search: null,
      sort: null,
      order: null,
      action: null,
      tenantIds: null,
      mapId: null,
    });
  }

  setAction(task, data) {
    this[task] = data;
  }

  resetData() {
    this.offset = 0;
    this.limit = 15;
    this.search = null;
    this.sort = null;
    this.order = null;
    this.tenantIds = null;
    this.maps = [];
  }

  async setData(task, data, getMap = true) {
    this[task] = data;
    if (getMap) {
      this.getMapList(this.offset, this.limit, this.search, this.sort, this.order, this.tenantIds);
    }
  }

  async clearMap() {
    this.map = {};
    this.mapData = [];
  }

  setMaps(data) {
    // includes array
    // const mapDuplicates = [];
    // data.map((val, index) => {
    //   if (!mapDuplicates.includes(val)) {
    //     mapDuplicates.push(val);
    //   }
    // });

    // use lodash
    const finalData = _.uniqBy(data, (e) => e.id);
    // this.mapData = finalData;
    this.allMapData = _.cloneDeep(finalData);
  }

  async setMapById(mapId) {
    let result = [];
    let mapDatas = _.cloneDeep(this.allMapData);
    const mapHiding = config.mapHiding;

    mapDatas = mapDatas.filter((val) => {
      if (val.id === mapId) {
        return true;
      }
      return !mapHiding.includes(val.id);
    });

    result = [...mapDatas.filter((val) => val.id !== mapId)];
    const tmp = mapDatas.find((item) => item.id === mapId);
    if (tmp) {
      result.unshift(tmp);
    }

    this.mapData = result;
  }

  async getMapId(id) {
    if (config.cache) {
      this.getMapById(id);
    } else {
      this._getMapById(id);
    }
  }

  async _getMapById(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/map/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const map = res.body || {};
        return (this.map = map);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        setTimeout(() => {
          clearLocalStorage();
          window.location.href = '/login';
        }, 1000);
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getMapById(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/map/${id}/cache`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const map = res.body || {};
        if (map) {
          return (this.map = map);
        } else {
          this._getMapById(id);
        }
      }
    } catch (err) {
      if (err.statusCode === 401) {
        setTimeout(() => {
          clearLocalStorage();
          window.location.href = '/login';
        }, 1000);
      }
      this._getMapById(id);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getMapByTenantId(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/map/basic/info/tenant/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const maps = res.body || {};
        this.mapsInfo = maps;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        setTimeout(() => {
          clearLocalStorage();
          window.location.href = '/login';
        }, 1000);
      }
      this._getMapById(id);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getMapList(offset = 0, limit = 15, search = null, sort = null, order = null, tenantIds = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.offset = offset;
    queryOption.limit = limit;
    if (tenantIds && tenantIds.length > 0) {
      queryOption.tenantIds = JSON.stringify(tenantIds);
    }
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/map`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const maps = res.body || {};
        return (this.maps = maps);
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async saveRouterPosition(data, id) {
    this.loading = true;
    try {
      const detail = {
        routers: data,
        mapId: id,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/router/point`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createMap(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        locationId: data.locationId,
        imgUrl: data.imgUrl,
        tenantId: data.tenantId,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/map`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateMap(data, task = null) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        locationId: data.locationId,
        imgUrl: data.imgUrl,
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/map/${data.id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteMaps(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/map/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new MapsStore();
